import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReturnInvoicesDetailsComponent } from './return-invoices-details.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosTotalsModule } from 'src/app/shared/pos-totals/pos-totals.module';
import { HasPrivilegeModule } from 'src/app/@core/directives/has-privilege/has-privilege.module';



@NgModule({
  declarations: [ReturnInvoicesDetailsComponent],
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule,
    PosTableModule,
    PosTotalsModule,
    HasPrivilegeModule
  ],
  exports: [ReturnInvoicesDetailsComponent]
})
export class ReturnInvoicesDetailsModule { }
